import { BaseModel } from './BaseModel';

export interface MapFileInfo {
    name: string;
    path: string;
    size: number;
    formattedSize: string;
    category: string;
}

export class CurrentMapFiles extends BaseModel {
    public worldSaves: MapFileInfo[] = [];
    public playerData: MapFileInfo[] = [];
    public blueprints: MapFileInfo[] = [];
    public totalSize: number = 0;
    public totalFiles: number = 0;
    public discoveredAt: string = '';
    public error?: string;

    public get hasFiles(): boolean {
        return this.totalSize > 0;
    }

    public get totalFilesCalculated(): number {
        return this.worldSaves.length + this.playerData.length + this.blueprints.length;
    }

    public get formattedTotalSize(): string {
        return this.formatBytes(this.totalSize);
    }

    private formatBytes(bytes: number): string {
        if (bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let unitIndex = 0;
        let size = bytes;

        while (size >= 1024 && unitIndex < units.length - 1) {
            size /= 1024;
            unitIndex++;
        }

        return `${Math.round(size * 100) / 100} ${units[unitIndex]}`;
    }
}
